import { useState } from 'react';

const useMockData = process.env.REACT_APP_USE_MOCK_DATA === 'true';

export function useUIState() {
  const [activeTab, setActiveTab] = useState('leaderboard');
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [comparePlayer, setComparePlayer] = useState(null);
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [isLoading, setIsLoading] = useState(!useMockData);

  // UI operation helpers
  const openMatchModal = () => {
    setShowMatchModal(true);
  };

  const closeMatchModal = () => {
    setShowMatchModal(false);
  };

  const openProfileModal = () => {
    setShowProfileModal(true);
  };

  const closeProfileModal = () => {
    setShowProfileModal(false);
  };

  return {
    // Tab state
    activeTab,
    setActiveTab,

    // Player selection state
    selectedPlayer,
    setSelectedPlayer,
    comparePlayer,
    setComparePlayer,

    // Modal state
    showMatchModal,
    setShowMatchModal,
    showProfileModal,
    setShowProfileModal,

    // Loading state
    isLoading,
    setIsLoading,

    // UI helpers
    openMatchModal,
    closeMatchModal,
    openProfileModal,
    closeProfileModal,
  };
}
